<div class="main-title">Customer Registration</div>
<div class="form-container">
    <div class="card-container">
        <div class="one-line-selection">
            <div class="title-label-one-line">
                <div class="title-label">Incident ID</div>
                <div class="dot3">:</div>
            </div>
            <div class="textfield-container">
                <div class="one-line-selection">
                    <mat-form-field class="selection-form" appearance="outline">
                        <mat-label>
                            <div class="selection-indicator-text">Incident ID</div>
                        </mat-label>
                        <input matInput class="input-field" [(ngModel)]="incidentId" />
                    </mat-form-field>
                </div>
            </div>
        </div>

    </div>
</div>